var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BasePage',_vm._g(_vm._b({attrs:{"list":_vm.filterList}},'BasePage',_vm.config,false),_vm.listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }